import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
  background: #141d2c;
  width: 100vw;
  height: 100vh;
`;